import * as prelude from '#gleam/prelude'

export function extract_sitemap(sitemapXml: string) {
  try {
    const parser = new DOMParser()
    const xmlDoc = parser.parseFromString(sitemapXml, 'application/xml')

    const locElements = Array.from(xmlDoc.getElementsByTagName('loc'))
    const urls = locElements
      .map(loc => loc.textContent?.split('#')[0].trim() || '')
      .filter(url => url !== '')

    const unique_urls = Array.from(new Set(urls))
    return prelude.toList(unique_urls)
  } catch (error) {
    return prelude.toList([])
  }
}
